<script setup lang="ts">
import { mdiChevronUp } from "@mdi/js";
import t from "~/utils/translate";
import { IMarket } from "~/types/sports/market";
import { IOutcome } from "~/types/sports/outcome";
import OutcomeRow from "~/components/layout/TrackRacing/Shared/Outcome/OutcomeRow.vue";
import OutcomeAdditionalInfo from "~/components/layout/TrackRacing/Shared/Outcome/OutcomeAdditionalInfo.vue";
import SpecialMarkets from "../Market/SpecialMarkets.vue";
import { isMobile } from "~/utils/constants";

interface Props {
	outcome: IOutcome;
	markets?: IMarket[];
	selectedEventId: number | undefined;
	isStartingPrice?: boolean;
	sportId: string;
}

defineProps<Props>();
const active = ref(false);
</script>
<template>
	<UiAccordion :activeIndex="1" :class="['overflow-hidden']" @tab-open="active = true" @tab-close="active = false">
		<UiAccordionTab
			:headerWrapperClass="'text-xs leading-none font-bold bg-light-50 dark:bg-dark-800 text-dark-300 dark:text-light-50 relative  pl-8 mb-[1px] overflow-hidden '"
			:disableToggle="false"
		>
			<template #header>
				<OutcomeRow
					:isStartingPrice="isStartingPrice || false"
					:outcome="outcome"
					:markets="markets || []"
					:event-id="selectedEventId ?? selectedEventId"
					:showAdditionalInfo="!isMobile"
					:sport-id="sportId"
				/>
			</template>
			<template #header-icon>
				<div class="absolute -translate-y-1/2 left-1 top-1/2 border border-light-500 dark:border-dark-500 rounded-md p-[4px] mr-1">
					<UiIcon
						:class="['z-10 w-[20px] h-[20px] fill-dark-500 dark:fill-light-50 transition-all', { 'rotate-180': !active }]"
						:path="mdiChevronUp"
					/>
				</div>
			</template>
			<div class="p-1 text-xs bg-light-200 dark:bg-dark-700 border border-light-400 dark:border-dark-500 border-b-0" v-if="active">
				<div v-if="isMobile">
					<SpecialMarkets :race-winner-outcome="outcome" :markets-on-main-view="markets?.map((m) => m.marketId)" />
					<OutcomeAdditionalInfo v-if="outcome?.additionalInfo && isMobile" :outcome-additional-info="outcome.additionalInfo" />
				</div>

				<div v-else class="leading-tight text-dark-300 dark:text-light-900 p-1">
					<span class="" v-if="outcome.additionalInfo?.TimeForm && outcome.additionalInfo?.TimeForm !== ''">
						{{ outcome.additionalInfo?.TimeForm }}
					</span>
					<div class="text-center text-xs font-semibold" v-else>
						{{ t("no-timeform-available") }}
					</div>
				</div>
			</div>
		</UiAccordionTab>
	</UiAccordion>
</template>
